import type { LogMessage, PaymentLogEntry } from "./payment";
import type { AddressProviderTreeNode, LogChunk } from "./socket";

interface LogGroup {
  header: string;
  logs: LogMessage[];
  result?: boolean;
}

interface ScrapingControlsProps {
  scraping: boolean;
  onScrape: () => void;
}

interface ScrapingHeaderProps {
  onBack: () => void;
  onClearLogs: () => void;
  hasLogs: boolean;
}

interface LiveLogsProps {
  entries: LogMessage[];
  payResults: PaymentLogEntry[] | null;
}

interface ScrapingScheduleResponse {
  scrapingTime: string | null;
  minInvoiceAmount: number | null;
}

interface AdminScrapingSchedule {
  userId: number;
  name: string | null;
  email: string;
  scrapingTime: string | null;
  isScheduled: boolean;
}

interface ScrapingSocketHandlers {
  onLog: (log: LogChunk) => void;
  onDone: () => void;
  onError: (message: string) => void;
}

interface ScrapingSocketConnection {
  disconnect: () => void;
}

enum NodeStatus {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  PENDING = "pending",
  WARN = "warn",
}

interface ScrapingInitResult {
  jobId: string;
  addressTree: AddressProviderTreeNode[];
}

interface ScrapingProviderData {
  id: string;
  name: string;
  status: NodeStatus;
}

interface ScrapingAddressData {
  addressName: string;
  status: NodeStatus;
  providers: ScrapingProviderData[];
}

export { NodeStatus };

export {
  type AdminScrapingSchedule,
  type LiveLogsProps,
  type LogGroup,
  type ScrapingAddressData,
  type ScrapingControlsProps,
  type ScrapingHeaderProps,
  type ScrapingInitResult,
  type ScrapingProviderData,
  type ScrapingScheduleResponse,
  type ScrapingSocketConnection,
  type ScrapingSocketHandlers,
};
